import { ComponentsOverrides, Theme } from "@mui/material";

type MuiOutlinedInput = {
  styleOverrides: ComponentsOverrides<Theme>["MuiOutlinedInput"];
};

const muiOutlinedInput: MuiOutlinedInput = {
  styleOverrides: {
    root: {
      padding: 0,
    },
    input: {
      padding: "16px 12px",
    },
    adornedStart: {
      paddingLeft: "12px",
    },
    adornedEnd: {
      paddingRight: "12px",
    },
    notchedOutline: {
      padding: "0px 7px",
    },
    inputSizeSmall: {
      padding: "8.5px 14px",
    },
  },
};

export default muiOutlinedInput;
